var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedMapMarker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Location Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Location Icon_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1148"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 3983",
    d: "M30.0145 6.65607C24.9951 6.66171 20.1828 8.6582 16.6335 12.2075C13.0842 15.7568 11.0877 20.5691 11.082 25.5886C11.082 38.5445 28.024 57.564 28.746 58.3665C28.9059 58.5445 29.1015 58.6869 29.3201 58.7844C29.5386 58.8818 29.7752 58.9322 30.0145 58.9322C30.2538 58.9322 30.4905 58.8818 30.709 58.7844C30.9276 58.6869 31.1232 58.5445 31.2831 58.3665C32.0051 57.5624 48.9471 38.5445 48.9471 25.5886C48.9414 20.5691 46.9449 15.7568 43.3956 12.2075C39.8463 8.6582 35.034 6.66171 30.0145 6.65607ZM30.0145 35.1131C28.1321 35.1131 26.2919 34.5549 24.7267 33.5091C23.1614 32.4632 21.9415 30.9767 21.2211 29.2375C20.5007 27.4983 20.3122 25.5846 20.6795 23.7383C21.0467 21.892 21.9532 20.1961 23.2843 18.8649C24.6155 17.5338 26.3114 16.6273 28.1577 16.2601C30.004 15.8928 31.9177 16.0813 33.6569 16.8017C35.3961 17.5221 36.8826 18.742 37.9284 20.3073C38.9743 21.8725 39.5325 23.7127 39.5325 25.5952C39.5277 28.118 38.5234 30.5362 36.7395 32.3201C34.9556 34.104 32.5374 35.1083 30.0145 35.1131Z",
    fill: "#CE343F"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedMapMarker);
export default __webpack_public_path__ + "static/media/redMapMarker.fa254b757a880d80024f0d0a1385c789.svg";
export { ForwardRef as ReactComponent };